import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_140';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: '', listHelp: ['159'/*,'222','223','224','225','160'*/] },
];

const tableStructure = [
  {id: 'desc', title: 'Descripción'}, 
  {id: 'procedencia', title: 'Procedencia'}, 
  {id: 'origen', title: 'Origen información'}, 
  {id: 'valActivo', title: 'Valor a declarar'},
];

class Form1 {
id: number;
desc: string;
procedencia: string;
valActivo:string;
origen:string;
}

class ArticulosDominio {
valor: number;
nombre: string;
}

@Component({
  selector: 'app-patrimonio-disponible-modal',
  templateUrl: './patrimonio-disponible-modal.component.html',
  styleUrls: ['./patrimonio-disponible-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class PatrimonioDisponibleModalComponent extends HandlerModal implements OnInit {

  saveModel = new EventEmitter();
  showSave:boolean; 
  dataSourceHeader = tableStructure;
  dataSourceBody = [];
  modelForm: Form1 = new Form1();
  OPERACION_NULA:number = 0;
  OPERACION_AGREGAR:number = 1;
  OPERACION_EDITAR:number = 2;
  OPERACION_BORRAR:number = 3; 
  operacionTabla:number = this.OPERACION_NULA;
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<PatrimonioDisponibleModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    console.log("disponible:"+this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_222 == undefined){

      this.model.doc.cuerpo.cc_id_222 = []; //descripcion
      this.model.doc.cuerpo.cc_id_223 = []; //procedencia
      this.model.doc.cuerpo.cc_id_224 = []; //origen
      this.model.doc.cuerpo.cc_id_225 = []; //valor
      this.model.doc.cuerpo.cs_id_162 = "0";
   
    }  
  }

  
  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.procedencia="";
    this.modelForm.valActivo="";
    this.modelForm.origen="";
  }
  


  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 169:
        this.operacionCs160();
        break;
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";

  }

  public operacionCs160(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valActivo, suma);
    }
    this.model.doc.cuerpo.cs_id_160 = suma;
  }

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_222.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_222[i].v;
      this.modelForm.procedencia=this.model.doc.cuerpo.cc_id_223[i].v;
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_224[i].v;
      this.modelForm.valActivo=this.model.doc.cuerpo.cc_id_225[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeSugerida(){
    let indexModel = this.model.doc.cuerpo.cc_id_222.length;

    
    if(indexModel==0){
      const fieldsRecovery = ['VAR_2190','VAR_1871','VAR_1995','VAR_7415','VAR_9001','VAR_7412'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      console.log(resData);
    
      if(resData)
      {
        for(let i=0; i<resData.length; i++){
          for(let j=0; j<resData[i].item.value.length; j++){
              this.modelForm.id=indexModel;
              this.modelForm.desc=resData[i].item.descVar[j];
              this.modelForm.procedencia=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];
              this.modelForm.origen="0";
              this.modelForm.valActivo=String(resData[i].item.value[j]);
              
              //VAR_1871 Solo se incluye si es positivo              
              let agregar:boolean = true;
              if (resData[i].key=="VAR_1871" && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelForm.valActivo, "0")) {
                agregar=false;
              }
              if(agregar){
                this.redondearFormData();
                this.dataSourceBody.push(this.modelForm);
                indexModel++;
              }
              this.inicializeForm();
          }
        }
        
      }
    }

    this.operacionCs160();
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc==null || this.modelForm.desc.trim()=="" ||
        this.modelForm.valActivo==undefined || /* this.modelForm.valCompra=="0" || */ 
        this.modelForm.origen==undefined || this.modelForm.origen==null || this.modelForm.procedencia==undefined
  }

  public redondearFormData(){
    this.modelForm.valActivo=this.dutilidades.redondearValorMoneda(this.modelForm.valActivo.toString(),true);
  }

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_222[this.modelForm.id].v=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_223[this.modelForm.id].v=this.modelForm.procedencia;
    this.model.doc.cuerpo.cc_id_224[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_225[this.modelForm.id].v=this.modelForm.valActivo.toString();

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_222.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_223.push({it: i, v:this.modelForm.procedencia});
    this.model.doc.cuerpo.cc_id_224.push({it: i, v:this.modelForm.origen});
    this.model.doc.cuerpo.cc_id_225.push({it: i, v:this.modelForm.valActivo.toString()});
    

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_222.splice(index,1);
    this.model.doc.cuerpo.cc_id_223.splice(index,1);
    this.model.doc.cuerpo.cc_id_224.splice(index,1);
    this.model.doc.cuerpo.cc_id_225.splice(index,1);

    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_222.length;i++){
      this.model.doc.cuerpo.cc_id_222[i].it=i+1;
      this.model.doc.cuerpo.cc_id_223[i].it=i+1;
      this.model.doc.cuerpo.cc_id_224[i].it=i+1;
      this.model.doc.cuerpo.cc_id_225[i].it=i+1;
    }
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){

        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
     
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_222.length;
        this.modelForm.origen = "2";
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs160();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs160();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
   
  }

 
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs160();
    this.dialogRef.close("");
  }
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_222 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    
    this.saveModel.emit(true); 
    this.closeModal();
  }

  public borrarTabla(){
    this.dataSourceBody = [];
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-disponible-modal/patrimonio-disponible-modal.component.ts